import { IconWrapper } from '../runtime';
export default IconWrapper('more', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M1 8C1 7.30964 1.55964 6.75 2.25 6.75C2.94036 6.75 3.5 7.30964 3.5 8C3.5 8.69036 2.94036 9.25 2.25 9.25C1.55964 9.25 1 8.69036 1 8ZM6.75 8C6.75 7.30964 7.30964 6.75 8 6.75C8.69036 6.75 9.25 7.30964 9.25 8C9.25 8.69036 8.69036 9.25 8 9.25C7.30964 9.25 6.75 8.69036 6.75 8ZM13.75 6.75C13.0596 6.75 12.5 7.30964 12.5 8C12.5 8.69036 13.0596 9.25 13.75 9.25C14.4404 9.25 15 8.69036 15 8C15 7.30964 14.4404 6.75 13.75 6.75Z",
      "fill": props.colors[0],
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});